import React from "react";

const NumberDisplay = ({
	number,
	minDigits = 0,
	maxDigits = 2,
	currency = true,
	block = true,
	style,
	...otherProps
}) => {
	const combinedStyle = number < 0 ? { color: "red", ...style } : style;
	const displayNumber = number || 0;
	return (
		<span
			className={currency ? "currency" : "align-right"}
			style={{ ...combinedStyle, display: block ? "block" : "inline" }}
			{...otherProps}
		>{`${Number(displayNumber).toLocaleString("en", {
			minimumFractionDigits: minDigits,
			maximumFractionDigits: maxDigits,
		})}`}</span>
	);
};

export default NumberDisplay;
